import Component from './ProfileMenu.vue';

export default {
  install(Vue) {
    Vue.component('BkfProfileMenu', Component);
  },
};
